var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFilter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fi-sr-settings-sliders",
    clipPath: "url(#clip0_793_2873)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.667566 3.16715H2.49138C2.85135 4.49158 4.21681 5.27344 5.54124 4.91348C6.39187 4.68228 7.05637 4.01779 7.28756 3.16715H15.3328C15.7009 3.16715 15.9994 2.86871 15.9994 2.50056C15.9994 2.13241 15.7009 1.83397 15.3328 1.83397H7.28756C6.9276 0.509511 5.56214 -0.272348 4.23771 0.0876158C3.38708 0.318812 2.72258 0.983308 2.49138 1.83394H0.667566C0.299416 1.83394 0.000976562 2.13238 0.000976562 2.50053C0.000976562 2.86868 0.299416 3.16715 0.667566 3.16715Z",
    fill: "#735BF2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.3328 7.33362H13.5089C13.1497 6.00938 11.785 5.22708 10.4607 5.5863C9.60943 5.81724 8.94437 6.48227 8.71342 7.33362H0.667566C0.299416 7.33362 0.000976562 7.63206 0.000976562 8.00021C0.000976562 8.36836 0.299416 8.6668 0.667566 8.6668H8.71342C9.07267 9.99104 10.4374 10.7733 11.7616 10.4141C12.6129 10.1832 13.278 9.51815 13.5089 8.6668H15.3328C15.7009 8.6668 15.9994 8.36836 15.9994 8.00021C15.9994 7.63206 15.7009 7.33362 15.3328 7.33362Z",
    fill: "#735BF2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M15.3328 12.833H7.28756C6.9276 11.5085 5.56214 10.7267 4.23771 11.0866C3.38708 11.3178 2.72258 11.9823 2.49138 12.833H0.667566C0.299416 12.833 0.000976562 13.1314 0.000976562 13.4996C0.000976562 13.8677 0.299416 14.1661 0.667566 14.1661H2.49138C2.85135 15.4906 4.21681 16.2724 5.54124 15.9125C6.39187 15.6813 7.05637 15.0168 7.28756 14.1661H15.3328C15.7009 14.1661 15.9994 13.8677 15.9994 13.4996C15.9994 13.1314 15.7009 12.833 15.3328 12.833Z",
    fill: "#735BF2"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_793_2873"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFilter);
export default __webpack_public_path__ + "static/media/iconFilter.36cdf35a6c28a756deb98a0b8a235d03.svg";
export { ForwardRef as ReactComponent };